import crud_actions from './crud_actions'
export const CLEAR_INVITABLES = 'clear_invitables'
export const CLEAR_SUGGESTED_GROUPS = 'clear_suggested_groups'
export const CLEAR_SUB_GROUPS = 'clear_sub_groups'
export const CLEAR_GROUP = 'clear_group'

export const clearGroup = opts => {
  return {
    type: CLEAR_GROUP,
    payload: opts
  }
}
export const upsertGroup = crud_actions.upsert('group', 'upsertGroup')
export const increasePrivacy = crud_actions.upsert('group', 'increasePrivacy')
export const updateEndUserDigestFrequency = crud_actions.update(
  'group',
  'updateEndUserDigestFrequency'
)
export const loadGroup = crud_actions.read('group', 'loadGroup')
export const pinIntroToGroup = crud_actions.update('group', 'pinIntroToGroup')
export const closeGroup = crud_actions.update('group', 'closeGroup')
export const reOpenGroup = crud_actions.update('group', 'reOpenGroup')
export const loadJoinedGroups = crud_actions.read('groups', 'loadJoinedGroups')
export const loadAvailableGroups = crud_actions.read(
  'discover',
  'loadAvailableGroups'
)
export const suggestGroups = crud_actions.read('groups', 'loadJoinedGroups')
export const clearSuggestedGroups = opts => {
  return {
    type: CLEAR_SUGGESTED_GROUPS,
    payload: opts
  }
}
export const discardInvitation = crud_actions.delete(
  'invitation',
  'discardInvitation'
)
export const joinGroup = crud_actions.upsert('membership', 'joinGroup')
export const leaveGroup = crud_actions.upsert('membership', 'leaveGroup')

export const inviteToGroup = crud_actions.upsert('invitations', 'invite')

export const findUsersToInvite = crud_actions.read(
  'invitables',
  'findUsersToInvite'
)

export const loadGroupMembers = crud_actions.read('members', 'loadMembers')
export const loadPendingInvites = crud_actions.read('invites', 'loadInvites')

export const updateMembership = crud_actions.update(
  'members',
  'updateMembership'
)

export const clearUsersToInvite = opts => {
  return {
    type: CLEAR_INVITABLES,
    payload: opts
  }
}

export const loadSubGroups = crud_actions.read('sub-groups', 'loadSubGroups')

export const clearSubGroups = opts => {
  return {
    type: CLEAR_SUB_GROUPS,
    payload: opts
  }
}

export const requestGroupAccess = crud_actions.upsert(
  'access_request',
  'requestGroupAccess'
)

export const loadAccessRequests = crud_actions.read(
  'access_requests',
  'loadAccessRequests'
)

export const grantAccessRequest = crud_actions.update(
  'access_requests',
  'grantAccessRequest'
)
export const denyAccessRequest = crud_actions.update(
  'access_requests',
  'denyAccessRequest'
)
